import React from 'react';
import { Link } from 'react-router-dom';
import { signOut } from '../../../../shared/api/authentication';
import { Icon } from '../../../shared';
import { userMenuList } from './user-menu-list';
import { useWorkflowStore } from '../../../store/workflowStore';
import './user-menu.scss';
import { useAppSelector } from '../../../app/hooks';
export var UserMenu = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, user = _a.user, userMenuVisible = _a.userMenuVisible, toggleUserMenu = _a.toggleUserMenu;
    var isAdmin = useAppSelector(function (state) { return state.adminData.adminData.isAdmin; });
    var userMenuClasses = 'c-user-menu';
    if (userMenuVisible) {
        userMenuClasses += ' isActive';
    }
    var listItems = !user ? [] : (user === null || user === void 0 ? void 0 : user.superUser) ? userMenuList : userMenuList.filter(function (item) { return !item.elevated; });
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    return (React.createElement("section", { className: userMenuClasses },
        React.createElement("header", { className: "c-user-menu__title" },
            React.createElement("h2", null, "My Account"),
            React.createElement("button", { type: "button", className: "c-user-menu__close", onClick: function () { return toggleUserMenu(!userMenuVisible); } },
                React.createElement(Icon, { name: "chevronRight" }))),
        React.createElement("p", { className: "c-user-menu__name" }, "".concat(firstName, " ").concat(lastName)),
        React.createElement("ul", { className: "c-user-menu__list" },
            isAdmin ? null : (listItems.map(function (menuItem) { return (React.createElement("li", { key: menuItem.linkName, className: "c-user-menu__item" },
                React.createElement(Link, { to: menuItem.linkPath, className: "c-user-menu__link", onClick: function () { return toggleUserMenu(!userMenuVisible); } },
                    React.createElement(Icon, { name: menuItem.icon }),
                    React.createElement("span", null, menuItem.linkName)))); })),
            React.createElement("li", { className: "c-user-menu__item c-user-menu__logout" },
                React.createElement("button", { type: "button", className: "c-user-menu__link", onClick: function () {
                        removeWorkflow();
                        signOut();
                    } },
                    React.createElement(Icon, { name: "signout" }),
                    React.createElement("span", null, "Log out"))))));
};
